var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.79476 0.215816C10.0825 -0.0719387 10.5491 -0.0719387 10.8368 0.215816L13.7842 3.16318C14.0719 3.45094 14.0719 3.91748 13.7842 4.20524L4.20524 13.7842C4.06705 13.9224 3.87963 14 3.68421 14H0.736842C0.329895 14 0 13.6701 0 13.2632V10.3158C0 10.1204 0.0776313 9.93295 0.215816 9.79476L7.58408 2.4265L9.79476 0.215816ZM8.10526 3.98942L1.47368 10.621V12.5263H3.379L10.0106 5.89474L8.10526 3.98942ZM11.0526 4.85268L12.2211 3.68421L10.3158 1.77889L9.14732 2.94737L11.0526 4.85268Z",
    fill: "#6E6E73"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.987d777fdb1748b0c88fbc351fbc3318.svg";
export { ForwardRef as ReactComponent };